import { legDistances } from './Leg';
import { idList, idObject } from '../../../utils/arrays';

function splice(route, idx, count, ...legs) {
  let distance = route.get('distance');
  let result = route;
  if (count > 0) {
    route
      .get('legs')
      .slice(idx, idx + count)
      .forEach(i => {
        const leg = route.get(i);
        distance -= leg.distance;
        result = result.delete(i);
      });
  }
  return result.merge({
    ...idObject(legs),
    distance: distance + legDistances(legs),
    legs: route.get('legs').splice(idx, count, ...idList(legs)),
  });
}

export default splice;
